import { FC } from "react";
import { getColorFromLetter } from "../../../common/Color";
import styles from "./ProjectCard.module.less";

interface VendorLogoProps {
    vendorHero?: string;
    vendorName?: string;
    projectName?: string;
}

export const VendorLogo: FC<VendorLogoProps> = ({ vendorHero, vendorName, projectName }) => {
    const vendorInitial = (vendorName || "").charAt(0).toUpperCase();
    const projectInitial = (projectName || "P").charAt(0).toUpperCase();
    const fallbackLetter = vendorName ? vendorInitial : projectInitial;
    const fallbackColor = getColorFromLetter(fallbackLetter);

    return (
        <div className={styles.logo}>
            {vendorHero ? (
                <img src={vendorHero} alt={vendorName} />
            ) : (
                <div className={styles.logoFallback} style={{ backgroundColor: fallbackColor }}>
                    {fallbackLetter}
                </div>
            )}
        </div>
    );
};
